/* GBattle landing: interactive Sweden train choice. Never touches the running game. */
(function(){
  'use strict';
  var GAME = '/pages/online-3d-graffiti-creator';
  var allowed = {'stockholm-c6':true,'stockholm-c30':true,'santiago-ns74':true,'paris-mp73':true,'london-2009stock':true};
  var destinations={
    se:{name:'SWEDEN',region:'EUROPE / SCANDINAVIA',rail:'STOCKHOLM UNDERGROUND',route:'TUNNELBANA',index:'001',coords:'59.3293° N / 18.0686° E',flag:'Swedish flag',train:'stockholm-c6'},
    cl:{name:'CHILE',region:'SOUTH AMERICA / SANTIAGO',rail:'METRO DE SANTIAGO',route:'SANTIAGO',index:'002',coords:'33.4489° S / 70.6693° W',flag:'Chilean flag',train:'santiago-ns74'},
    fr:{name:'FRANCE',region:'EUROPE / PARIS',rail:'MÉTRO DE PARIS',route:'PARIS',index:'003',coords:'48.8566° N / 2.3522° E',flag:'French flag',train:'paris-mp73'},
    uk:{name:'UNITED KINGDOM',region:'EUROPE / LONDON',rail:'LONDON UNDERGROUND',route:'LONDON',index:'004',coords:'51.5074° N / 0.1278° W',flag:'British flag',train:'london-2009stock'}
  };
  function init(root){
    if(root.dataset.gbhReady==='1') return;
    root.dataset.gbhReady='1';
    // Connected counter placeholder: deterministic per Stockholm minute.
    var activity = root.querySelector('[data-gbh-activity]');
    var activityCount = root.querySelector('[data-gbh-count]');
    if(activity && activityCount){
      var clock = new Intl.DateTimeFormat('en-GB', {
        timeZone:'Europe/Stockholm', year:'numeric', month:'2-digit', day:'2-digit',
        hour:'2-digit', minute:'2-digit', hourCycle:'h23'
      });
      var timer = null;
      var renderPulse = function(){
        var parts = {};
        clock.formatToParts(new Date()).forEach(function(p){if(p.type !== 'literal')parts[p.type]=Number(p.value);});
        var hour=parts.hour, minute=parts.minute;
        var dayKey=parts.year*10000+parts.month*100+parts.day;
        var seed=(Math.imul(dayKey, 1664525)^Math.imul(hour+1, 2246822519)^Math.imul(minute+1, 3266489917))>>>0;
        seed^=seed>>>16;seed=Math.imul(seed,2246822507)>>>0;
        seed^=seed>>>13;seed=Math.imul(seed,3266489909)>>>0;
        seed^=seed>>>16;
        var random=seed/4294967296;
        // Nighttime is quieter; afternoon/evening has stronger activity.
        var hourTargets=[120,110,100,95,145,165,180,230,310,350,400,440,
          480,500,510,530,575,610,670,710,690,575,400,250];
        var base=hourTargets[hour];
        var spread=hour<6?65:hour<12?100:145;
        var count=Math.max(0,Math.min(1000,Math.round(base+(random-.5)*2*spread)));
        activityCount.textContent=String(count);
        activity.dataset.gbhHour=String(hour);
      };
      var schedulePulse = function(){
        renderPulse();
        if(timer!==null)clearTimeout(timer);
        timer=setTimeout(schedulePulse,60000-Date.now()%60000+120);
      };
      schedulePulse();
      document.addEventListener('visibilitychange',function(){
        if(!document.hidden)schedulePulse();
      });
    }
    var choices = root.querySelectorAll('[data-gbh-train]');
    var enter = root.querySelector('[data-gbh-enter]');
    var productImage = root.querySelector('[data-gbh-product-image]');
    var productTitle = root.querySelector('[data-gbh-product-title]');
    var productSubtitle = root.querySelector('[data-gbh-product-subtitle]');
    var countryBtns = root.querySelectorAll('[data-gbh-country]');
    var countryGroups = root.querySelectorAll('[data-gbh-country-trains]');
    var currentCountry='se';
    var mapPreviewImage = root.querySelector('[data-gbh-map-preview-image]');
    var mapPreviewTitle = root.querySelector('[data-gbh-map-preview-title]');
    var mapPreviewSubtitle = root.querySelector('[data-gbh-map-preview-subtitle]');
    var launchOverlay = root.querySelector('[data-gbh-launch]');
    function updateMapPreview(selectedBtn){
      if(!selectedBtn) return;
      if(mapPreviewImage && selectedBtn.dataset.gbhImage){
        mapPreviewImage.src = selectedBtn.dataset.gbhImage;
        mapPreviewImage.alt = selectedBtn.dataset.gbhImageAlt || 'Train preview';
      }
      if(mapPreviewTitle) mapPreviewTitle.textContent = selectedBtn.dataset.gbhTitle || '';
      if(mapPreviewSubtitle) mapPreviewSubtitle.textContent = selectedBtn.dataset.gbhSubtitle || '';
      root.dispatchEvent(new CustomEvent('gbh:preview-update',{detail:{
        country: currentCountry,
        image: selectedBtn.dataset.gbhImage || '',
        imageAlt: selectedBtn.dataset.gbhImageAlt || 'Train preview',
        title: selectedBtn.dataset.gbhTitle || '',
        subtitle: selectedBtn.dataset.gbhSubtitle || ''
      }}));
    }
    function beginTransition(url, modeLabel){
      document.documentElement.classList.add('gbh-page-leaving');
      document.body.classList.add('gbh-page-leaving');
      if(launchOverlay){
        launchOverlay.hidden = false;
        launchOverlay.classList.remove('is-2d','is-3d','is-entering');
        launchOverlay.classList.add(modeLabel === '2D' ? 'is-2d' : 'is-3d');
        requestAnimationFrame(function(){ launchOverlay.classList.add('is-entering'); });
      }
      window.setTimeout(function(){ window.location.href = url; }, 140);
    }
    function wireSmoothLinks(){
      var links = root.querySelectorAll('a[href]');
      links.forEach(function(link){
        var href = link.getAttribute('href') || '';
        if(!href || href.charAt(0)==='#' || link.dataset.gbhLinked==='1') return;
        if(href.indexOf('/pages/online-3d-graffiti-creator')===-1 && href.indexOf('/pages/live-graffiti')===-1) return;
        link.dataset.gbhLinked='1';
        var prefetch = function(){
          if(link.dataset.gbhPrefetched==='1') return;
          link.dataset.gbhPrefetched='1';
          var p = document.createElement('link'); p.rel='prefetch'; p.href=href; document.head.appendChild(p);
        };
        link.addEventListener('mouseenter', prefetch, {passive:true});
        link.addEventListener('focus', prefetch, {passive:true});
        link.addEventListener('click', function(e){
          if(e.defaultPrevented || e.button!==0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          beginTransition(href, href.indexOf('/pages/live-graffiti')!==-1 ? '2D' : '3D');
        });
      });
    }
    if(!enter || !choices.length) return;
    function choose(id){
      if(!Object.prototype.hasOwnProperty.call(allowed,id))return;
      var selectedBtn=null;
      choices.forEach(function(btn){
        var selected=btn.getAttribute('data-gbh-train')===id;
        btn.classList.toggle('is-selected',selected);
        btn.setAttribute('aria-pressed',String(selected));
        if(selected) selectedBtn=btn;
      });
      if(!selectedBtn)return;
      enter.href=selectedBtn.getAttribute('data-gbh-url')||(GAME+'?gb3train='+encodeURIComponent(id));
      enter.setAttribute('aria-label','Go paint '+selectedBtn.querySelector('strong').textContent+' in 3D');
      if(productImage&&selectedBtn.dataset.gbhImage){
        productImage.src=selectedBtn.dataset.gbhImage;
        productImage.alt=selectedBtn.dataset.gbhImageAlt||'Train preview';
      }
      if(productTitle)productTitle.textContent=selectedBtn.dataset.gbhTitle||'';
      if(productSubtitle)productSubtitle.textContent=selectedBtn.dataset.gbhSubtitle||'';
      updateMapPreview(selectedBtn);
    }
    function chooseCountry(code,trainId){
      var d=destinations[code];if(!d)return;
      currentCountry=code;
      countryBtns.forEach(function(btn){var active=btn.dataset.gbhCountry===code;
        btn.setAttribute('aria-pressed',String(active));btn.classList.toggle('is-selected',active);
      });
      countryGroups.forEach(function(group){group.hidden=group.dataset.gbhCountryTrains!==code;});
      var title=root.querySelector('[data-gbh-country-title]');if(title)title.textContent=d.name;
      var region=root.querySelector('[data-gbh-country-region]');if(region)region.textContent=d.region;
      var rail=root.querySelector('[data-gbh-country-rail]');if(rail)rail.textContent=d.rail;
      var route=root.querySelector('[data-gbh-country-route]');if(route)route.textContent=d.route;
      var label=root.querySelector('[data-gbh-destination-label]');if(label)label.textContent='DESTINATION '+d.index+' — AVAILABLE NOW';
      var flag=root.querySelector('[data-gbh-flag]');if(flag){flag.className='gbh-flag gbh-flag--'+code;flag.setAttribute('aria-label',d.flag);}
      var coords=root.querySelector('[data-gbh-coordinates]');if(coords)coords.textContent=d.coords;
      var count=root.querySelector('[data-gbh-train-count]');if(count)count.textContent=code==='se'?'02 AVAILABLE':'01 AVAILABLE';
      choose(trainId&&allowed[trainId]?trainId:d.train);
      root.dispatchEvent(new CustomEvent('gbh:country-focus',{detail:{country:code}}));
    }
    countryBtns.forEach(function(btn){btn.addEventListener('click',function(){chooseCountry(btn.dataset.gbhCountry);});});
    choices.forEach(function(btn){btn.addEventListener('click',function(){choose(btn.dataset.gbhTrain);});});
    root.addEventListener('gbh:country-select',function(e){
      if(e.detail&&destinations[e.detail.country]){
        chooseCountry(e.detail.country);
        var target=root.querySelector('.gbh-country-card');
        if(target)target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'nearest'});
      }
    });
    chooseCountry('se');
    wireSmoothLinks();
  }
  function start(){document.querySelectorAll('[data-gbh-home]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);
  else start();
  // Support Shopify theme editor section re-renders.
  document.addEventListener('shopify:section:load',start);
})();

/* GBattle premium globe: accurate Natural Earth coastline, offline texture, no third-party scripts. */
(function(){
  'use strict';
  const PI=Math.PI, DEG=PI/180, clamp=(x,min,max)=>Math.max(min,Math.min(max,x));
  const countryData=window.GBattleHomeWorld;
  function initMap(section){
    const holder=section.querySelector('[data-gbh-map]');
    if(!holder||holder.dataset.gbhMapReady==='1')return;
    const canvas=holder.querySelector('[data-gbh-globe]');
    const markers=[...holder.querySelectorAll('[data-gbh-marker]')];
    const stage=holder.querySelector('.gbh-globe-stage');
    if(!canvas||!stage)return;
    const grid=section.querySelector('.gbh-world-grid');
    const preview=grid && grid.querySelector('[data-gbh-map-preview]');
    const previewCard=preview && preview.querySelector('[data-gbh-map-preview-card]');
    const previewLine=preview && preview.querySelector('[data-gbh-map-preview-line]');
    const previewImage=preview && preview.querySelector('[data-gbh-map-preview-image]');
    const previewTitle=preview && preview.querySelector('[data-gbh-map-preview-title]');
    const previewSubtitle=preview && preview.querySelector('[data-gbh-map-preview-subtitle]');
    let previewCountry='se';
    // Country-to-photo connector uses SVG coordinates in the shared grid.
    // CSS-transform bars were susceptible to layout/stacking problems and
    // could disappear when the selected marker was hidden on the far hemisphere.
    const svgNS='http://www.w3.org/2000/svg';
    const connector=preview && document.createElementNS(svgNS,'svg');
    const connectorLine=connector && document.createElementNS(svgNS,'line');
    const connectorDot=connector && document.createElementNS(svgNS,'circle');
    if(connector && connectorLine && connectorDot){
      connector.setAttribute('aria-hidden','true');
      connector.classList.add('gbh-world-connector');
      connector.style.cssText='position:absolute;inset:0;width:100%;height:100%;overflow:visible;z-index:0;pointer-events:none;display:block;';
      connectorLine.setAttribute('stroke','#FFC90E');
      connectorLine.setAttribute('stroke-width','4');
      connectorLine.setAttribute('stroke-linecap','round');
      connectorLine.setAttribute('vector-effect','non-scaling-stroke');
      connectorDot.setAttribute('r','5');
      connectorDot.setAttribute('fill','#FFC90E');
      connectorDot.setAttribute('stroke','#090d13');
      connectorDot.setAttribute('stroke-width','1.5');
      connector.appendChild(connectorLine);
      connector.appendChild(connectorDot);
      // The supplied Liquid has a placeholder bar; keep its markup but never draw it.
      if(previewLine)previewLine.style.setProperty('display','none','important');
      preview.insertBefore(connector,preview.firstChild);
    }
    let rimDirection={x:1,y:0};
    function positionPreview(){
      if(!preview || !previewCard || !connector || !grid)return;
      if(window.matchMedia('(max-width:800px)').matches){
        preview.hidden=true;
        return;
      }
      const marker=markers.find(m=>m.dataset.gbhCountryMarker===previewCountry);
      if(!marker)return;
      const gridBox=grid.getBoundingClientRect();
      const mapBox=holder.getBoundingClientRect();
      const globeBox=canvas.getBoundingClientRect();
      const gridW=gridBox.width,gridH=gridBox.height;
      if(!gridW || !gridH || !globeBox.width)return;
      const lon=Number(marker.dataset.gbhLon)*DEG;
      const lat=Number(marker.dataset.gbhLat)*DEG;
      const p=projection(lon,lat);
      const globeR=globeBox.width*.465*state.zoom;
      const projected=Math.hypot(p.x,p.y);
      // Freeze the rim direction near the hidden hemisphere's central singularity.
      // Otherwise allow the connector to travel along the silhouette while dragging.
      if(projected>.12){
        rimDirection={x:p.x/projected,y:-p.y/projected};
      }
      const isFront=p.z>.025;
      const dx=isFront ? p.x*globeR : rimDirection.x*globeR*.985;
      const dy=isFront ? -p.y*globeR : rimDirection.y*globeR*.985;
      const anchorX=globeBox.left-gridBox.left+globeBox.width*.5+dx;
      const anchorY=globeBox.top-gridBox.top+globeBox.height*.5+dy;
      preview.hidden=false;
      const cardWidth=previewCard.getBoundingClientRect().width||300;
      const cardHeight=previewCard.getBoundingClientRect().height||182;
      const targetLeft=mapBox.right-gridBox.left-cardWidth*.70;
      const cardX=clamp(Math.max(anchorX+38,targetLeft),24,gridW-cardWidth-18);
      const cardY=clamp(anchorY-cardHeight*.94,95,gridH-cardHeight-70);
      previewCard.style.left=cardX.toFixed(2)+'px';
      previewCard.style.top=cardY.toFixed(2)+'px';
      // Connect to the image boundary, choosing the nearer horizontal side.
      const attachToLeft=anchorX<=cardX+cardWidth*.5;
      const endX=attachToLeft ? cardX : cardX+cardWidth;
      const endY=clamp(anchorY,cardY+14,cardY+cardHeight-14);
      connector.setAttribute('viewBox',`0 0 ${gridW} ${gridH}`);
      connectorLine.setAttribute('x1',anchorX.toFixed(2));
      connectorLine.setAttribute('y1',anchorY.toFixed(2));
      connectorLine.setAttribute('x2',endX.toFixed(2));
      connectorLine.setAttribute('y2',endY.toFixed(2));
      connectorDot.setAttribute('cx',anchorX.toFixed(2));
      connectorDot.setAttribute('cy',anchorY.toFixed(2));
      connector.style.visibility='visible';
      preview.setAttribute('aria-hidden','false');
    }
    const ctx=canvas.getContext('2d',{alpha:true});
    if(!ctx)return;
    holder.dataset.gbhMapReady='1';
    const source=document.createElement('canvas'); source.width=2048;source.height=1024;
    const sctx=source.getContext('2d',{willReadFrequently:true});
    const ocean=sctx.createLinearGradient(0,0,0,source.height);
    ocean.addColorStop(0,'#3d6fa8');
    ocean.addColorStop(.32,'#2a5a90');
    ocean.addColorStop(.62,'#1c4a7c');
    ocean.addColorStop(1,'#0b2344');
    sctx.fillStyle=ocean;sctx.fillRect(0,0,source.width,source.height);
    const oceanGlow=sctx.createRadialGradient(source.width*.5,source.height*.46,source.height*.06,source.width*.5,source.height*.46,source.width*.52);
    oceanGlow.addColorStop(0,'rgba(126,174,226,.22)');
    oceanGlow.addColorStop(.5,'rgba(63,120,178,.09)');
    oceanGlow.addColorStop(1,'rgba(0,0,0,0)');
    sctx.fillStyle=oceanGlow;sctx.fillRect(0,0,source.width,source.height);
    // Geographic grid and cartographic depth.
    sctx.strokeStyle='rgba(162,207,236,.18)';sctx.lineWidth=.9;sctx.globalAlpha=.8;
    for(let lon=-180;lon<=180;lon+=30){const x=(lon+180)/360*source.width;sctx.beginPath();sctx.moveTo(x,0);sctx.lineTo(x,source.height);sctx.stroke();}
    for(let lat=-75;lat<=75;lat+=15){const y=(90-lat)/180*source.height;sctx.beginPath();sctx.moveTo(0,y);sctx.lineTo(source.width,y);sctx.stroke();}
    sctx.globalAlpha=1;
    const landPalette=['#7ca064','#88a56d','#97a96f','#a59b74','#76976a','#6e8f62'];
    const coastPalette=['#bfcea7','#c7d2b2','#cad1a9','#d1c09a','#b2c59e','#a8c0a0'];
    function latTint(lat){
      if(lat>60)return 'rgba(236,241,234,.8)';
      if(lat>35)return 'rgba(209,193,151,.19)';
      if(lat>-12 && lat<12)return 'rgba(80,138,81,.16)';
      if(lat<-42)return 'rgba(205,194,168,.17)';
      return 'rgba(0,0,0,0)';
    }
    if(Array.isArray(countryData)){
      countryData.forEach(function(entry,index){
        const code=entry[0],poly=entry[1];
        if(!poly || poly.length<3)return;
        sctx.beginPath();
        let active=false,px=0,sumLat=0,count=0;
        poly.forEach(function(pt){
          let x=(pt[0]+180)/360*source.width,y=(90-pt[1])/180*source.height;
          sumLat+=pt[1];count++;
          if(!active||Math.abs(x-px)>source.width*.5){sctx.moveTo(x,y);active=true;}else sctx.lineTo(x,y);
          px=x;
        });
        const avgLat=count?sumLat/count:0;
        if(code==='SWE'||code==='CHL'||code==='FRA'||code==='GBR'){
          sctx.fillStyle='#ffc90e';sctx.strokeStyle='#fff3a3';sctx.lineWidth=1.75;
        }else{
          let shade=index%landPalette.length;
          sctx.fillStyle=landPalette[shade];
          sctx.strokeStyle=coastPalette[shade];
          sctx.lineWidth=1.0;
        }
        sctx.fill();sctx.stroke();
        if(code!=='SWE'){
          sctx.save();
          sctx.fillStyle=latTint(avgLat);
          sctx.fill();
          sctx.restore();
        }
      });
    }
    // Add subtle top-tier texture depth: cloud veils, polar ice haze and ocean bloom.
    const cloudBand=(cx,cy,rx,ry,alpha)=>{
      const g=sctx.createRadialGradient(cx,cy,0,cx,cy,Math.max(rx,ry));
      g.addColorStop(0,'rgba(255,255,255,'+alpha+')');
      g.addColorStop(.55,'rgba(237,246,255,'+(alpha*.42)+')');
      g.addColorStop(1,'rgba(255,255,255,0)');
      sctx.fillStyle=g;
      sctx.beginPath();
      sctx.ellipse(cx,cy,rx,ry,0,0,PI*2);
      sctx.fill();
    };
    sctx.globalCompositeOperation='screen';
    [[260,170,170,48,.08],[520,210,220,52,.07],[840,300,260,60,.08],[1130,240,240,56,.07],[1460,350,210,50,.065],[1730,240,190,46,.06],[1900,420,180,50,.05]].forEach(v=>cloudBand(...v));
    // Polar caps / arctic mist.
    const polarTop=sctx.createLinearGradient(0,0,0,120); polarTop.addColorStop(0,'rgba(242,248,251,.46)'); polarTop.addColorStop(1,'rgba(242,248,251,0)');
    sctx.fillStyle=polarTop; sctx.fillRect(0,0,source.width,140);
    const polarBot=sctx.createLinearGradient(0,source.height-120,0,source.height); polarBot.addColorStop(0,'rgba(242,248,251,0)'); polarBot.addColorStop(1,'rgba(240,244,248,.22)');
    sctx.fillStyle=polarBot; sctx.fillRect(0,source.height-120,source.width,120);
    // Subtle ocean gloss stripe.
    const gloss=sctx.createLinearGradient(source.width*.15,0,source.width*.85,0);
    gloss.addColorStop(0,'rgba(255,255,255,0)');
    gloss.addColorStop(.48,'rgba(255,255,255,.02)');
    gloss.addColorStop(.5,'rgba(150,214,255,.065)');
    gloss.addColorStop(.52,'rgba(255,255,255,.02)');
    gloss.addColorStop(1,'rgba(255,255,255,0)');
    sctx.fillStyle=gloss; sctx.fillRect(0,0,source.width,source.height);
    sctx.globalCompositeOperation='source-over';
    // Make the map seamless at the antimeridian.
    const tex=sctx.getImageData(0,0,source.width,source.height);
    const pixels=tex.data,tw=source.width,th=source.height;
    const state={lon:18.0686,lat:43.0,zoom:0.96,drag:false,x:0,y:0,touch:null,visible:true,last:0,rendered:false,selected:'se'};
    let framePending=false,animId=0,side=0,backing=null;
    const stockholm=[18.0686*DEG,59.3293*DEG];
    function projection(lon,lat){
      const dl=lon-state.lon*DEG,cl=state.lat*DEG;
      const xp=Math.cos(lat)*Math.sin(dl);
      const yp=Math.cos(cl)*Math.sin(lat)-Math.sin(cl)*Math.cos(lat)*Math.cos(dl);
      const zp=Math.sin(cl)*Math.sin(lat)+Math.cos(cl)*Math.cos(lat)*Math.cos(dl);
      return {x:xp,y:yp,z:zp};
    }
    function updateMarkers(){
      const d=canvas.getBoundingClientRect(),r= d.width*.465*state.zoom,view=stage.getBoundingClientRect();
      markers.forEach(function(marker){
        const lon=Number(marker.dataset.gbhLon)*DEG,lat=Number(marker.dataset.gbhLat)*DEG;
        const p=projection(lon,lat);
        marker.hidden=p.z<=.025;
        if(marker.hidden)return;
        marker.style.left=(d.left-view.left+d.width/2+p.x*r)+'px';
        marker.style.top=(d.top-view.top+d.height/2-p.y*r)+'px';
        marker.classList.toggle('is-active',marker.dataset.gbhCountryMarker===state.selected);
      });
      positionPreview();
    }
    function resize(){
      // Fit a square canvas inside BOTH dimensions of the map stage.
      // Canvas backing resolution must not alter the CSS layout dimensions.
      const style=window.getComputedStyle(stage);
      const availableWidth=stage.clientWidth-parseFloat(style.paddingLeft)-parseFloat(style.paddingRight);
      const availableHeight=stage.clientHeight-parseFloat(style.paddingTop)-parseFloat(style.paddingBottom);
      const displayW=Math.floor(Math.min(470,availableWidth,availableHeight));
      if(!Number.isFinite(displayW) || displayW<100)return;
      canvas.style.width=displayW+'px';
      canvas.style.height=displayW+'px';
      const next=clamp(Math.round(displayW*Math.min(window.devicePixelRatio||1,1.3)),120,650);
      if(next!==side){side=next;canvas.width=side;canvas.height=side;backing=ctx.createImageData(side,side);}
      draw();
    }
    function draw(){
      if(!side||!backing||!state.visible)return;
      const out=backing.data;
      const R=side*.465*state.zoom,c=side/2,cosLat=Math.cos(state.lat*DEG),sinLat=Math.sin(state.lat*DEG);
      const startLon=state.lon*DEG;
      for(let y=0;y<side;y++){
        const ny=(c-y)/R,ny2=ny*ny,row=y*side*4;
        for(let x=0;x<side;x++){
          const nx=(x-c)/R,z2=1-nx*nx-ny2,i=row+x*4;
          if(z2<=0){out[i+3]=0;continue;}
          const z=Math.sqrt(z2);
          const lat=Math.asin(clamp(ny*cosLat+z*sinLat,-1,1));
          const lon=startLon+Math.atan2(nx,z*cosLat-ny*sinLat);
          let sx=Math.floor((lon/PI/2+.5)*tw),sy=Math.floor((.5-lat/PI)*th);
          sx=(sx%tw+tw)%tw;sy=clamp(sy,0,th-1);
          const ti=(sy*tw+sx)*4;
          const baseR=pixels[ti], baseG=pixels[ti+1], baseB=pixels[ti+2];
          const light=clamp(.40+.58*z+.14*(-nx+ny),.22,1.04);
          let r=Math.min(255,baseR*light), g=Math.min(255,baseG*light), b=Math.min(255,baseB*light);
          const isLand=(baseG>baseB*.9 && baseG>52) || (baseR>110 && baseG>90 && baseB<120);
          if(isLand && light<.46 && sy>110 && sy<th-120){
            const warm=(.46-light)*62;
            r=Math.min(255,r+warm*1.8); g=Math.min(255,g+warm*1.15); b=Math.min(255,b+warm*.32);
          }
          if(!isLand && light>.82){
            const waterSheen=(light-.82)*34;
            r=Math.min(255,r+waterSheen*.28); g=Math.min(255,g+waterSheen*.6); b=Math.min(255,b+waterSheen);
          }
          out[i]=r; out[i+1]=g; out[i+2]=b; out[i+3]=255;
        }
      }
      ctx.clearRect(0,0,side,side);
      ctx.putImageData(backing,0,0);
      // Elegant disk linework and atmosphere.
      ctx.save();ctx.translate(c,c);
      const rad=R;
      let glow=ctx.createRadialGradient(0,0,rad*.68,0,0,rad*1.15);
      glow.addColorStop(0,'rgba(54,180,198,0)');
      glow.addColorStop(.64,'rgba(49,119,176,.05)');
      glow.addColorStop(.9,'rgba(106,181,223,.16)');
      glow.addColorStop(1,'rgba(106,181,223,0)');
      ctx.fillStyle=glow;ctx.beginPath();ctx.arc(0,0,rad*1.14,0,2*PI);ctx.fill();
      const sheen=ctx.createRadialGradient(-rad*.18,-rad*.24,rad*.1,-rad*.1,-rad*.15,rad*.9);
      sheen.addColorStop(0,'rgba(255,255,255,.18)');
      sheen.addColorStop(.22,'rgba(183,221,248,.09)');
      sheen.addColorStop(1,'rgba(255,255,255,0)');
      ctx.fillStyle=sheen;ctx.beginPath();ctx.arc(0,0,rad,0,2*PI);ctx.fill();
      const shadow=ctx.createRadialGradient(rad*.15,rad*.2,rad*.12,rad*.28,rad*.25,rad*1.1);
      shadow.addColorStop(0,'rgba(0,0,0,0)');
      shadow.addColorStop(.72,'rgba(0,0,0,.06)');
      shadow.addColorStop(1,'rgba(0,0,0,.16)');
      ctx.fillStyle=shadow;ctx.beginPath();ctx.arc(0,0,rad,0,2*PI);ctx.fill();
      const rim=ctx.createLinearGradient(-rad, -rad*.3, rad, rad*.3);
      rim.addColorStop(0,'rgba(255,255,255,.03)');
      rim.addColorStop(.45,'rgba(255,255,255,0)');
      rim.addColorStop(.55,'rgba(255,255,255,0)');
      rim.addColorStop(1,'rgba(255,255,255,.07)');
      ctx.strokeStyle='rgba(219,239,250,.36)';ctx.lineWidth=1.6;ctx.beginPath();ctx.arc(0,0,rad,0,PI*2);ctx.stroke();
      ctx.strokeStyle=rim;ctx.lineWidth=2.4;ctx.beginPath();ctx.arc(0,0,rad*.995,0,PI*2);ctx.stroke();
      ctx.strokeStyle='rgba(254,227,77,.16)';ctx.lineWidth=1;
      ctx.beginPath();ctx.arc(0,0,rad*1.032,-.22,2.45);ctx.stroke();
      ctx.restore();
      updateMarkers();
      state.rendered=true;
    }
    function redraw(){if(framePending)return;framePending=true;requestAnimationFrame(()=>{framePending=false;resize();});}
    // Keep the globe still unless the visitor interacts: no continuous animation cost.
    canvas.addEventListener('pointerdown',e=>{
      state.drag=true;state.x=e.clientX;state.y=e.clientY;
      canvas.setPointerCapture(e.pointerId);
      canvas.classList.add('is-dragging');
    });
    canvas.addEventListener('pointermove',e=>{
      if(!state.drag)return;
      const dx=e.clientX-state.x,dy=e.clientY-state.y;
      state.lon=((state.lon-dx*.36+540)%360)-180;
      state.lat=clamp(state.lat+dy*.22,-69,75);
      state.x=e.clientX;state.y=e.clientY;redraw();
    });
    const endDrag=()=>{state.drag=false;canvas.classList.remove('is-dragging');};
    canvas.addEventListener('pointerup',endDrag);canvas.addEventListener('pointercancel',endDrag);
    canvas.addEventListener('lostpointercapture',endDrag);
    canvas.addEventListener('wheel',e=>{e.preventDefault();state.zoom=clamp(state.zoom+(e.deltaY<0?.075:-.075),.82,1.025);redraw();},{passive:false});
    holder.querySelectorAll('[data-gbh-zoom]').forEach(b=>b.addEventListener('click',()=>{
      state.zoom=clamp(state.zoom+(b.dataset.gbhZoom==='in'?.10:-.10),.82,1.025);redraw();
    }));
    const reset=holder.querySelector('[data-gbh-reset]');
    const centers={se:[18.0686,59.3293],cl:[-70.6693,-33.4489],fr:[2.3522,48.8566],uk:[-0.1278,51.5074]};
    function focusCountry(code){
      if(!centers[code])return;
      const geo=centers[code];state.selected=code;
      state.lon=geo[0];state.lat=clamp(geo[1]*.72,-65,70);
      state.zoom=.96;redraw();
    }
    if(reset)reset.addEventListener('click',()=>focusCountry(state.selected));
    markers.forEach(marker=>marker.addEventListener('click',()=>{
      section.dispatchEvent(new CustomEvent('gbh:country-select',{detail:{country:marker.dataset.gbhCountryMarker}}));
    }));
    section.addEventListener('gbh:country-focus',e=>{ previewCountry = e.detail.country; focusCountry(e.detail.country); });
    section.addEventListener('gbh:preview-update',e=>{
      if(!e.detail) return;
      previewCountry = e.detail.country || previewCountry;
      if(previewImage && e.detail.image) previewImage.src = e.detail.image;
      if(previewImage && e.detail.imageAlt) previewImage.alt = e.detail.imageAlt;
      if(previewTitle) previewTitle.textContent = e.detail.title || '';
      if(previewSubtitle) previewSubtitle.textContent = e.detail.subtitle || '';
      positionPreview();
    });
    const ro=typeof ResizeObserver!=='undefined'?new ResizeObserver(redraw):null;
    if(ro)ro.observe(stage);else window.addEventListener('resize',redraw);
    if(typeof IntersectionObserver!=='undefined'){
      new IntersectionObserver(entries=>{state.visible=entries[0].isIntersecting;if(state.visible)redraw();},{rootMargin:'100px'}).observe(holder);
    }
    redraw();
  }
  function start(){document.querySelectorAll('[data-gbh-home]').forEach(initMap);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();
